import React, { Component } from 'react';
import { withTranslation, Trans } from 'react-i18next';
import validator from 'validator'
class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      api_url: process.env.REACT_APP_API_URL,
      uploaded_image_url: process.env.REACT_APP_CRYPTO_API_URL,
      /*      api_url: 'http://localhost:5000',
            uploaded_image_url: 'http://localhost/bitkart/public/images/',*/
    };
    this.getSetting = this.getSetting.bind(this)
  }

  componentDidMount() {
    this.getSetting();
  }

  getSetting() {
    fetch(this.state.api_url + '/getSetting', { method: "get" })
      .then((res) => res.json())
      .then((data) => {
        this.setState({ data })
      })
      .catch(err => console.log(err))
  }

  handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.target)
    const email = data.get('newsletter_email')
    //console.log(email)
    this.setState({ showemailError: false })
    this.setState({ emailSuccess: false })
    if (email === '') {
      this.setState({ showemailError: true })
      this.setState({ emailSuccess: false })
      this.setState({ emailErrorMessage: 'Please enter email first' })
    } else if (!validator.isEmail(email)) {
      //alert(45345)
      this.setState({ showemailError: true })
      this.setState({ emailSuccess: false })
      this.setState({ emailErrorMessage: 'Please enter valid email' })
    } else {

      fetch(this.state.api_url + '/saveNewsletter', {
        method: 'POST',
        body: JSON.stringify(email)
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === 1) {
            this.setState({ showemailError: true })
            this.setState({ emailSuccess: false })
            this.setState({ emailErrorMessage: data.message })
          } else {
            this.setState({ showemailError: false })
            this.setState({ emailSuccess: true })
            this.setState({ emailSuccessMessage: data.message })
          }
          //console.log(data.message)
        })
    }
  }

  render() {
    const _data = this.state.data;
    //  console.log(_data)
    return (
      <div>
        <footer className="footer-section">
          <div className="container">
            <div className="row">
              <div className="col-xl-10 offset-xl-1">
                <form className="newsletter" onSubmit={this.handleSubmit}>
                  <div className="subscribe-box wow bounceInRight" data-wow-delay="0.3s">
                    <label className="control-label"><Trans>Get the latest crypto news in your inbox</Trans>.</label>
                    <div className="input-group">
                      <input type="text" className="form-control" placeholder="Enter your Email" id="newsletter_email" name="newsletter_email" />
                      <div className="input-group-append">
                        <button className="btn btn-primary" type="submit" id="newsletter_submit" ><span><i className="fa fa-long-arrow-right" aria-hidden="true"></i></span></button>
                      </div>
                    </div>
                    {
                      (this.state.showemailError === true || this.state.emailSuccess === true) &&
                      <div className="clearfix">&nbsp;</div>
                    }
                    {
                      this.state.showemailError === true &&
                      <span id="msgspan" style={{ 'color': '#ff0000', 'fontSize': '16px', 'borderRadius': '10px', 'marginRight': '25%', 'fontWeight': 'bold', 'float': 'right', 'margin-top': '-1%' }}>{this.state.emailErrorMessage}</span>
                    }
                    {
                      this.state.emailSuccess === true &&
                      <span id="msgspan" style={{ 'color': 'green', 'fontSize': '16px', 'borderRadius': '10px', 'fontWeight': 'bold', 'float': 'right', 'margin-top': '-1%' }}>{this.state.emailSuccessMessage}</span>
                    }
                  </div>
                </form>

              </div>
            </div>

            <div className="row">

              <div className="col-xl-2 col-lg-2 col-md-4 col-sm-4 wow bounceInLeft" data-wow-delay="0.5s">
                <img src="/img/cpe.png" alt="Logo" className="footer-logo" />
                <ul>
                  <li><a href="https://cryptop2p.in/privacy-policy" rel="noopener noreferrer"><Trans>Privacy Policy</Trans></a></li>
                  <li><a href="https://cryptop2p.in/user-agreement" rel="noopener noreferrer"><Trans>User Agreement</Trans></a></li>
                  <li><a href="https://cryptop2p.in/refund-and-return-policy" rel="noopener noreferrer"><Trans>Refund & Return Policy</Trans></a></li>
                  <li><a href="https://cryptop2p.in/terms-&-conditions" rel="noopener noreferrer"><Trans>Terms of Use</Trans></a></li>

                </ul>

              </div>

              <div className="col-xl-3 col-lg-3 col-md-4 col-sm-5 wow bounceInLeft" data-wow-delay="0.4s">
                <h5><Trans>Products & Services</Trans></h5>
                <ul>
                  <li><a href="https://cryptop2p.in" rel="noopener noreferrer"><Trans>Get Started</Trans></a></li>
                  <li><a href="https://markets.cryptop2p.in/" rel="noopener noreferrer"><Trans>Markets</Trans></a></li>
                  <li><a href="#"><Trans>Wallet</Trans></a></li>
                  <li><a href="https://cryptop2p.in/exchanges"><Trans>Exchange</Trans></a></li>

                </ul>
              </div>

              <div className="col-xl-2 col-lg-2 col-md-4 col-sm-3 wow bounceInLeft" data-wow-delay="0.3s">
                <h5><Trans>Stable Currencies</Trans></h5>
                <ul>
                  <li><a href="https://markets.cryptop2p.in/detail/tether"><Trans>Tether</Trans></a></li>
                  <li><a href="https://markets.cryptop2p.in/detail/usd-coin"><Trans>USD Coin</Trans></a></li>
                  <li><a href="https://markets.cryptop2p.in/detail/binance-coin"><Trans>Binance USD</Trans></a></li>
                  {/* <li><a href="https://markets.cryptop2p.in/detail/paxos-standard"><Trans>Paxos Standard</Trans></a></li> */}
                  <li><a href="https://markets.cryptop2p.in/detail/true-usd"><Trans>True USD</Trans></a></li>
                </ul>

              </div>



              <div className="col-xl-2 col-lg-2 col-md-4 col-sm-5 wow bounceInRight" data-wow-delay="0.4s">
                <h5><Trans>Company</Trans></h5>
                <ul>
                  <li><a href="https://cryptop2p.in/about-us" rel="noopener noreferrer"><Trans>About</Trans></a></li>
                  <li><a href="https://cryptop2p.in/advertise" rel="noopener noreferrer"><Trans>Advertise</Trans></a></li>
                  <li><a href="https://cryptop2p.in/press-media" rel="noopener noreferrer"><Trans>Press & Media</Trans></a></li>
                  <li><a href="https://cryptop2p.in/all-blogs" rel="noopener noreferrer"><Trans>Blog</Trans></a></li>
                  <li><a href="https://cryptop2p.in/contact-us" rel="noopener noreferrer"><Trans>Contact</Trans></a></li>
                  <li><a href="#"><Trans>Partners</Trans></a></li>
                  <li><a href="#"><Trans>Support</Trans></a></li>
                </ul>
              </div>

              <div className="col-xl-1 col-lg-1 col-md-4 col-sm-3 wow bounceInRight" data-wow-delay="0.5s">
                <div className="social-list" id="follow_ul_content">
                  <a target="_blank" rel="noopener noreferrer" className="btn btn-primary" href={_data.telegram_url}><span><i className="fa fa-telegram" aria-hidden="true"></i></span></a>
                  <a className="btn btn-primary" rel="noopener noreferrer" target="_blank" href={_data.youtube_url}><span><i className="fa fa-youtube" aria-hidden="true"></i></span></a>
                  <a className="btn btn-primary" rel="noopener noreferrer" target="_blank" href={_data.instagram_url}><span><i className="fa fa-instagram" aria-hidden="true"></i></span></a>
                  <a className="btn btn-primary" rel="noopener noreferrer" target="_blank" href={_data.twitter_url}><span><i className="fa fa-twitter" aria-hidden="true"></i></span></a>
                  <a className="btn btn-primary" rel="noopener noreferrer" target="_blank" href={_data.reddit_url}><span><i className="fa fa-reddit" aria-hidden="true"></i></span></a>
                  <a className="btn btn-primary" rel="noopener noreferrer" target="_blank" href={_data.facebook_url}><span><i className="fa fa-facebook" aria-hidden="true"></i></span></a>
                </div>
              </div>
            </div>
            <div className="copyright">
              <p>&copy; 2023-2024 Crypto P2P Exchange <Trans>All rights reserved</Trans>.</p>
            </div>
          </div>
        </footer>
      </div>
    )
  }
}

export default withTranslation('translations')(Footer);